module.exports = __webpack_public_path__ + "static/media/yamaha.1ed00980.png";